import lpApp from '../app/lp_app';

export default function evaluateOperation(operation, variable, id) {
  const varREGEX = /\[var:([0-9]+)\]/gi;

  const getVarValue = (variableId) => {
    let value = 0;
    let variableFromId;
    // If is multiple
    if (/^([0-9]+)_(.*)$/.test(id)) {
      const suffix = id.split('_')[1];
      if (lpApp.indexes.variables.variables.hasOwnProperty(`${variableId}_${suffix}`)) {
        variableFromId = lpApp.indexes.variables.getVariable(`${variableId}_${suffix}`);
      } else {
        variableFromId = lpApp.indexes.variables.getVariable(variableId);
      }
    } else {
      variableFromId = lpApp.indexes.variables.getVariable(variableId);
    }

    if (variableFromId) {
      value = variableFromId.value;
      if (typeof (value) === 'string') value = value.replace(',', '.');
      value = parseFloat(value);
    }


    return value;
  };

  const cleanedOperation = operation.replace(varREGEX, (a, b) => {
    // var value = _this.variables_wrapper[b].value;

    // Checking if B is a cibling
    const value = getVarValue(b);

    return Number.isNaN(value) ? 0 : value;
  });

  let result = 0;

  try {
    result = eval(cleanedOperation);
    if (result === Infinity) result = 0;
  } catch (exception_var_1) {
    result = 0;
  }

  if (Number.isNaN(result)) { result = 0; }

  // Decimal
  const decimals = (variable.eval_decimal) ? parseInt(variable.eval_decimal, 10) : 2;
  const round = (variable.round) ? parseInt(variable.round, 10) : 0;

  let decma = 1;
  for (let i = 0; i < decimals; i += 1) {
    decma *= 10;
  }

  // Round
  switch (round) {
    case 0:
      result = Math.round(result * decma) / decma;
      break;
    case 1:
      result = Math.ceil(result * decma) / decma;
      break;
    case 2:
      result = Math.floor(result * decma) / decma;
      break;
  }
  // console.log("The result is:" + result);
  return result;
}



// WEBPACK FOOTER //
// ./src/logic/evaluate_operation.js